import {
  DEFAULT_SCROLL_OFFSET_TOP,
  SCROLL_TARGET_KIND,
  type ScrollTargetKind,
} from "./scroll-controller-constants";
import type {
  PendingScrollRequest,
  QueuePendingTargetScrollInput,
  ScrollBottomOptions,
} from "./scroll-controller-types";

type PendingTargetIds = Pick<
  PendingScrollRequest,
  "targetMessageId" | "targetVersionId"
>;

const PENDING_TARGET_ID_FACTORIES: Record<
  ScrollTargetKind,
  (targetId: string) => PendingTargetIds
> = {
  [SCROLL_TARGET_KIND.Message]: (targetId) => ({
    targetMessageId: targetId,
    targetVersionId: null,
  }),
  [SCROLL_TARGET_KIND.Version]: (targetId) => ({
    targetMessageId: null,
    targetVersionId: targetId,
  }),
};

export function createPendingBottomScrollRequest(
  opts?: ScrollBottomOptions,
): PendingScrollRequest {
  return {
    targetMessageId: null,
    targetVersionId: null,
    toBottom: true,
    instant: !!opts?.instant,
    offsetTop: DEFAULT_SCROLL_OFFSET_TOP,
  };
}

export function createPendingTargetScrollRequest({
  targetId,
  targetKind,
  opts,
}: QueuePendingTargetScrollInput): PendingScrollRequest {
  return {
    ...PENDING_TARGET_ID_FACTORIES[targetKind](targetId),
    toBottom: false,
    instant: !!opts?.instant,
    offsetTop: opts?.offsetTop ?? DEFAULT_SCROLL_OFFSET_TOP,
  };
}
